import { HttpClient } from './serviceBase';

class LoginService {
    GetLogin = async (redirectUrl) =>
        await HttpClient.Get(`/api/login?redirectUrl=${redirectUrl}`);

    GetToken = async (redirectUrl, authCode) =>
        await HttpClient.Get(`/api/login/auth?redirectUrl=${redirectUrl}&code=${authCode}`);
}

export default new LoginService();